import React from "react";
import { Item, BoxItem } from "../types";

interface KastGridProps {
  boxCount: number;
  boxItems: BoxItem[];
  onBoxClick: (boxIndex: number) => void;
  getItemById: (id: string) => Item | undefined;
}

const KastGrid: React.FC<KastGridProps> = ({
  boxCount,
  boxItems,
  onBoxClick,
  getItemById,
}) => {
  // Calculate grid layout based on box count
  const getGridLayout = (count: number) => {
    if (count === 12) return "grid-cols-3";
    if (count === 24) return "grid-cols-4";
    if (count === 36) return "grid-cols-6";
    return "grid-cols-3";
  };

  const gridLayout = getGridLayout(boxCount);

  return (
    <div className={`grid ${gridLayout} gap-2`}>
      {Array.from({ length: boxCount }, (_, index) => {
        const boxItem = boxItems.find((bi) => bi.boxIndex === index);
        const item = boxItem ? getItemById(boxItem.itemId) : null;

        return (
          <div
            key={index}
            onClick={() => onBoxClick(index)}
            className={`
              aspect-square border-2 rounded-lg cursor-pointer transition-all duration-200 flex items-center justify-center
              ${
                item
                  ? "border-blue-500 bg-blue-50 hover:bg-blue-100"
                  : "border-gray-300 hover:border-gray-400 hover:bg-gray-50"
              }
            `}
          >
            {item ? (
              <div className="text-center">
                <img
                  src={item.thumbnail}
                  alt={item.name}
                  className="w-8 h-8 rounded mx-auto mb-1 object-cover"
                />
                <p className="text-xs text-gray-600 truncate px-1">
                  {item.name}
                </p>
              </div>
            ) : (
              <div className="text-center text-gray-400">
                <div className="text-xs font-medium">Vak {index + 1}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KastGrid;
